"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "jss", {
  enumerable: true,
  get: function get() {
    return _reactJss.jss;
  }
});
Object.defineProperty(exports, "JssProvider", {
  enumerable: true,
  get: function get() {
    return _reactJss.JssProvider;
  }
});
exports.createUseStyles = exports.theming = exports.useTheme = exports.withStyles = exports.ThemeProvider = exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireWildcard(require("react-jss"));

require("../theme/sheet");

var _index = _interopRequireDefault(require("./index"));

/* eslint-disable @typescript-eslint/ban-types */

/* eslint-disable @typescript-eslint/no-explicit-any */
// Creating a namespaced theming object.
var ThemeContext = React.createContext(_index["default"]);
var theming = (0, _reactJss.createTheming)(ThemeContext);
exports.theming = theming;
var ThemeProvider = theming.ThemeProvider,
    useTheme = theming.useTheme;
exports.useTheme = useTheme;
exports.ThemeProvider = exports["default"] = ThemeProvider;

var withStyles = function withStyles(makeStyles) {
  return function (Component) {
    //@ts-ignore
    return (0, _reactJss["default"])(makeStyles, {
      theming: theming
    })(Component);
  };
};

exports.withStyles = withStyles;

var createUseStyles = function createUseStyles(styles) {
  return (//@ts-ignore
    (0, _reactJss.createUseStyles)(styles, {
      theming: theming
    })
  );
};

exports.createUseStyles = createUseStyles;
//# sourceMappingURL=ThemeProvider.js.map